import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { environment } from 'src/environments/environment';
import { ImpersonationService } from '../../impersonation/impersonation.service';
import { UserDetails } from 'src/app/core/models/user-details.model';

@Component({
    selector: 'top-navbar-left',
    templateUrl: './top-navbar-left.component.html',
    styleUrls: ['./top-navbar-left.component.scss']
})

export class TopNavBarLeftComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];
    isSmeView = false;
    isClientManagerView = false;
    userDetails: UserDetails;

    constructor(
        private _userDataService: UserDataService,
        private _router: Router,
        private impersonationService: ImpersonationService,
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(this._userDataService.userDetails$.subscribe(userData => {
            if (userData && userData.roleId) {
                this.userDetails = userData;
            }
        }));

        this.subscriptions.push(
            this.impersonationService.smeUserDetails$.subscribe(details => {
                this.isSmeView = !!details;
            }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    navigateToLandingPage(): void {
        if (window.location.origin.includes('rcnsurvey')) {
            location.replace(environment.redirectUri);
            return;
        }
        if (!this.isSmeView) {
            const routeToNavigate = this._userDataService.getLandingPageBasedOnRole(this.userDetails.roleId);
            this._router.navigate([routeToNavigate], {
                queryParamsHandling: 'preserve',
            });
        } else {
            this._router.navigate(['/surveys/client-sme'], {
                queryParamsHandling: 'preserve'
            });
        }
    }
}
